import { Component } from '@angular/core';

@Component({
    selector: 'nst2t1',
    templateUrl: './nst2t1.component.html',
    styleUrl: './nst2t1.component.scss',
    standalone: false
})
export class Nst2t1Component {

}
